import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import CardService from '../services/CardService';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import AccountService from '../services/AccountService';
class OrderCardDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.state = {
            approvals: this.props.agreementsToAccept,
            acceptedTerms: {},
        };
        this.cardService = new CardService();
        this.accountService = new AccountService();
        
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    acceptTermsAndOpenOrderCard(type) {
        const {acceptedTerms} = this.state;
        const {agreementsToAccept} = this.props;
        const acceptedApprovals = agreementsToAccept.filter(a => acceptedTerms[a.approvalType] == true);
        const simplifyAcceptedApprovals = acceptedApprovals.map(({petraAgreementId, approvalType }) => ({petraAgreementId, approvalType,accepted: true}));
        if (this.validator.allValid()) {
            if(agreementsToAccept?.length > 0){
            this.cardService.acceptTermsBeforeNextStep(simplifyAcceptedApprovals)
                .then((res) => {
                    if (res.result === true) {
                         if(res.token){
                                this.authService.setToken(res.token);
                            }
                        if (type === 'NEW') {
                            window.location.href = this.props.newUrl;
                        } else {
                            this.saveCookie(`order-card-list-activeIndex`, 2);
                            window.location.href = this.props.templateUrl;
                        }
                    }
                }).catch((err) => {
                    this.showErrorMessage("Nie udało się zaakceptować regulaminów.")
                })
            } else {
                 if (type === 'NEW') {
                            window.location.href = this.props.newUrl;
                        } else {
                            this.saveCookie(`order-card-list-activeIndex`, 2);
                            window.location.href = this.props.templateUrl;
                        }
            }

        } else {
            this.validator.showMessages();
            this.forceUpdate();
            this.scrollToError = true;
        }

    }


    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('cards.newOrdering')}
                    variant={'button cancel-button blue'}
                    handleClick={() => {
                       this.acceptTermsAndOpenOrderCard('NEW');

                    }
                        }
                />
                <ActionButton
                    label={t('cards.fromTemplate')}
                    variant='button save-button blue'
                    handleClick={() => {
                        this.acceptTermsAndOpenOrderCard('TEMPLATE');
                    }}
                />
            </div>
        );
    }
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label id='ordering-question'>{t('cards.orderTypeQuestion')}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    blockUi() {}
    unblockUi() {}
    setElement() {}

    renderDetails() {
        const {t, agreementsToAccept} = this.props;
        return (
            <>
                <div className='row'>
                    <label id={`order-description`} className='col-12 title-label'>
                        {t('cards.orderingDescription')}
                    </label>
                </div>
                <div className='row' style={{ marginTop: '15px' }}>
                    {this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK' ?
                        agreementsToAccept?.map((approval, index) => {
                            const label = approval.contents
                                .map((str) => {
                                    return str.type === 'TRANSLATE'
                                        ? t(`${str.content}`)
                                        : `<a href="${str.linkUrl}" target="_blank">${t(str.linkLabel)}</a> `;
                                })
                                .join('');
                            return (
                                <div>
                                    <InputCheckboxComponent
                                        id={`approval-${approval.approvalType}`}
                                        key={`approval-order-card-${approval.approvalType}-${index}`}
                                        name={`${approval.approvalType}`}
                                        label={label}
                                        labelOnRight
                                        value={this.state.acceptedTerms[`${approval.approvalType}`]}
                                        //value={approval.accepted}
                                        onChange={this.handleChange}
                                        stateField={`acceptedTerms`}
                                        validator={this.validator}
                                        validators = {'required|checkbox_checked_required'}                                            
                                        viewMode='NEW'
                                        colClass='col-12'
                                        labelClassName='hybrid-approval-content-title'
                                        required={!!approval.required}
                                        renderRequired={!!approval.required}
                                        validatorLabel=''
                                        onAfterStateChange={() => {}}

                                    />

                                </div>

                            );
                        }) : null}
                </div>
            </>

        );
    }
}

OrderCardDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
    templateUrl: '/#/card-order-list',
    newUrl: '/#/order-card-new',
    agreementsToAccept: [],
};

OrderCardDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    cardNumbers: PropTypes.array,
    agreementsToAccept: PropTypes.array,
};

export default withTranslation()(OrderCardDialog);
